import { View } from "react-native";
import React from "react";
import { Skeleton } from "moti/skeleton";
import dimensions from "../../../../../globalStyles/dimensions";

const AllExperienceLoader = () => {
  return (
    <>
      <View
        style={{
          gap: 10,
          paddingHorizontal: dimensions.paddingHorizontal,
          paddingTop: dimensions.paddingVertical * 2,
        }}
      >
        <View style={{ gap: 4 }}>
          <Skeleton width={250} height={36} radius={8} colorMode="light" />
          <Skeleton width={200} height={20} radius={8} colorMode="light" />
        </View>
        <Skeleton
          width={dimensions.windowWidth / 1.12}
          height={380}
          radius={20}
          colorMode="light"
        />
      </View>
      <View
        style={{
          gap: 10,
          paddingHorizontal: dimensions.paddingHorizontal,
          paddingVertical: dimensions.paddingVertical,
        }}
      >
        <Skeleton width={300} height={30} radius={8} colorMode="light" />
      </View>
      <View
        style={{
          flexDirection: "row",
          marginLeft: dimensions.marginHorizontal,
          gap: 10,
        }}
      >
        <View
          style={{
            gap: 10,
          }}
        >
          <Skeleton
            width={dimensions.windowWidth / 2.2}
            height={180}
            radius={8}
            colorMode="light"
          />
          <Skeleton width={150} height={20} radius={8} colorMode="light" />
          <Skeleton width={130} height={20} radius={8} colorMode="light" />
        </View>
        <View
          style={{
            gap: 10,
          }}
        >
          <Skeleton
            width={dimensions.windowWidth / 2.2}
            height={180}
            radius={8}
            colorMode="light"
          />
          <Skeleton width={150} height={20} radius={8} colorMode="light" />
          <Skeleton width={130} height={20} radius={8} colorMode="light" />
        </View>
        <View
          style={{
            gap: 10,
          }}
        >
          <Skeleton
            width={dimensions.windowWidth / 2.2}
            height={180}
            radius={8}
            colorMode="light"
          />
          <Skeleton width={150} height={20} radius={8} colorMode="light" />
          <Skeleton width={130} height={20} radius={8} colorMode="light" />
        </View>
      </View>
    </>
  );
};

export default AllExperienceLoader;
